import { useRef } from 'react';
import {
  Box,
  Center,
  Group,
  LoadingOverlay,
  Pagination,
  ScrollArea,
  Stack,
  Text,
} from '@mantine/core';

type CardListProps = {
  isLoading: boolean;
  isEmpty?: boolean;
  children: React.ReactNode;
  currentPage: number;
  totalItems: number;
  totalPages: number;
  startIndex: number;
  endIndex: number;
  onPageChange: (page: number) => void;
};

export function CardList({
  isLoading,
  children,
  isEmpty = false,
  currentPage,
  totalItems,
  totalPages,
  startIndex,
  endIndex,
  onPageChange,
}: CardListProps) {
  const scrollAreaViewportRef = useRef<HTMLDivElement>(null);

  const handlePageChange = (page: number) => {
    onPageChange(page);
    scrollAreaViewportRef.current?.scrollTo({ top: 0 });
  };

  return (
    <Box pos="relative">
      <LoadingOverlay visible={isLoading} />
      {isEmpty && (
        <Center py="xl">
          <Text size="sm" c="dimmed">
            目前無 Tickets
          </Text>
        </Center>
      )}
      {!isEmpty && !isLoading && (
        <Stack gap="md" h="63dvh" mih={0}>
          <ScrollArea
            flex={1}
            mih={0}
            offsetScrollbars="present"
            scrollbars="y"
            type="auto"
            viewportRef={scrollAreaViewportRef}
          >
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
              {children}
            </div>
          </ScrollArea>
          <Group justify="space-between" align="center">
            <Text size="sm" c="dimmed">
              顯示 {startIndex + 1} - {endIndex} 筆，共 {totalItems} 筆
            </Text>
            <Pagination
              total={totalPages}
              value={currentPage}
              onChange={handlePageChange}
              size="sm"
            />
          </Group>
        </Stack>
      )}
    </Box>
  );
}
